/*
 * @Author: 黄智强
 * @Date: 2018-01-12 16:37:09
 * @Last Modified by: 黄智强
 * @Last Modified time: 2018-02-09 13:49:10
 * @说明：省市区(region)相关的所有接口地址定义
 */
// 获取省、市、区
export const getRegionList = '/region/list'
// 获取省
export const getProvince = '/region/get-province'
// 获取市、区
export const getRegion = '/region/get-region'



// WEBPACK FOOTER //
// ./src/api/url/region.js